import React, { useState, useContext, useRef, useEffect } from 'react';
import { CustomDropdownProfil } from '../utilityComponents/customDropdown';
import { ModalChangeProfilPhoto, ModalPersonalInfo } from '../utilityComponents/customModal';
import { BaseContext } from '../contexts/baseContext';

import img from '../../docs/fondGris.png';
import photo from '../../docs/renard3.png';

function ProfilInterface() {
  const [user, setUser] = useState({
    number: "+23765087323",
    username: "Dilane",
    bio: ""
  });
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  // const [croppedArea, setCroppedArea] = useState(null);
  const [show, setShow] = useState(false);

  const { navigateTo, profilSectionHeight } = useContext(BaseContext);

  const inputFileRef = useRef();

  useEffect(() => {
    let inputFile = document.querySelector(".select-files");
    let timerId

    inputFile.addEventListener("change", () => {
      timerId = setTimeout(() => {
        setShow(true);

        clearInterval(timerId);
      }, 100)
    });
  })

  const handleOpenFileSystem = () => inputFileRef.current.click();

  const handleChangeInfo = (event) => {
    let us = {...user};
    const id = event.target.id;

    if (id === "input-1") {
      us.number = event.target.value;
    } else if (id === "input-2") {
      us.username = event.target.value;
    } else if (id === "input-3") {
      us.bio = event.target.bio;
    }

    setUser(us);
  }

  const handleCropChange = (crop) => {
    setCrop(crop);
  }

  // const handleCropComplete = (croppedArea, croppedAreaPixels) => {
  //   console.log(croppedArea, croppedAreaPixels)
  //   setCroppedArea(croppedAreaPixels);
  // }

  const handleZoomChange = (zoom) => {
    setZoom(zoom);
  }

  const handleSelectImage = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.addEventListener("load", () => {
        console.log(reader.result);
        setImage(reader.result);
      })
    }
  }

  return (
    <>
      <section className="profil-header">
        <div className="profil-header--image">
          <div className="profil-header--icon-control">
            <div className="backgroun-icon">
              <i className="bi bi-arrow-left-short" onClick={() => navigateTo("contacts")}></i>
            </div>
            <CustomDropdownProfil onSelectImage={handleOpenFileSystem}>
              <div className="backgroun-icon">
                <i className="bi bi-three-dots-vertical"></i>
              </div>
            </CustomDropdownProfil>
          </div>
          <img src={img} alt="profil" data-src={ photo }/>

          <div className="profil-header--info">
            <span>{ user.username }</span>
            <small>online</small>
          </div>

          <div className="profil-header--icone-photo" onClick={handleOpenFileSystem}>
            <i className="bi bi-camera-fill"></i>
          </div>
          <input
            type="file"
            accept="image/*"
            className="d-none select-files"
            ref={inputFileRef}
            onChange={handleSelectImage}
          />
          <ModalChangeProfilPhoto
            show={show}
            image={image}
            crop={crop}
            zoom={zoom}
            onCropChange={handleCropChange}
            onZoomChange={handleZoomChange}
            setClose={() => setShow(false)}
          />
        </div>
      </section>
      <section className="profil-body" style={{ height: `${profilSectionHeight}px` }}>
        <h5>
          Account
        </h5>
        <div className="profil-body--info">
          <article className="profil-item">
            <div className="profil-item--numero">
              <span>+23765087323</span>
              <span>Phone number</span>
            </div>
            <ModalPersonalInfo
              title="Change phone number"
            >
              <input
                id="input-1"
                value={user.number}
                type="text"
                className="form-control"
                placeholder="new phone number..."
                onChange={handleChangeInfo}
              />
            </ModalPersonalInfo>
          </article>
          <article className="profil-item">
            <div className="profil-item--name">
              <span>Dilane</span>
              <span>Usename</span>
            </div>
            <ModalPersonalInfo
              title="Change username"
            >
              <input
                id="input-2"
                value={user.username}
                type="text"
                className="form-control"
                placeholder="new username..."
                onChange={handleChangeInfo}
              />
            </ModalPersonalInfo>
          </article>
          <article className="profil-item">
            <div className="profil-item--bio">
              <span>Bio</span>
              <span>a short description of me...</span>
            </div>
            <ModalPersonalInfo
              title="Change biography"
            >
              <input
                id="input-3"
                value={user.bio}
                type="text"
                className="form-control"
                placeholder="new bio..."
                onChange={handleChangeInfo}
              />
            </ModalPersonalInfo>
          </article>
        </div>
      </section>
    </>
  );
}

export default ProfilInterface;
